export default "__VITE_ASSET__DI0f8Ymb__"